import script from "./AddViolationParameters.vue?vue&type=script&setup=true&lang=js"
export * from "./AddViolationParameters.vue?vue&type=script&setup=true&lang=js"

import "./AddViolationParameters.vue?vue&type=style&index=0&id=4ba5e0e9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba5e0e9"]])

export default __exports__